import React, { FC } from 'react';
import { Popover } from 'antd';
import PurchaseRequestStatusDisplay from './PurchaseRequestStatusDisplay';
import RemovedStatusDisplay from '../purchase_order_status_display/RemovedStatusDisplay';
import { UserNameWithEmail } from '../name_component/user/UserNameWithEmail';
import { PURCHASE_REQUEST_STATUSES } from '../../constants/PurchaseRequestStatuses';
import { dateFormatterWithoutTimeZone } from '../../utils/DataFormatterUtils';

const CancellationSummary: FC<{ lineItem: any }> = ({ lineItem }) => {
	const { cancelledByEmail, cancelledAt, cancelReason } = lineItem;
	return (
		<div className="bodyregular flex max-w-80 flex-col gap-xs text-character-primary">
			{/* UserNameWithEmail renders nothing for an unresolved contact, so it stands on its
			    own line (hidden when empty) rather than inside a "by …" phrase. */}
			{cancelledByEmail && (
				<div className="empty:hidden">
					<UserNameWithEmail email={cancelledByEmail} mode="inline" showNameWithAvatar />
				</div>
			)}
			<div>
				Cancelled
				{cancelledAt ? ` on ${dateFormatterWithoutTimeZone(cancelledAt)}` : ''}
			</div>
			{cancelReason && (
				<div>
					<span className="text-character-secondary">Reason: </span>
					{cancelReason}
				</div>
			)}
		</div>
	);
};

// Status chip for a single PR line item; a cancelled line shows who cancelled it, when
// and why on hover.
export const PRLineItemStatusDisplay: FC<{ lineItem: any }> = ({ lineItem }) => {
	if (lineItem.isDeleted) {
		return <RemovedStatusDisplay />;
	}
	const chip = <PurchaseRequestStatusDisplay status={lineItem.status} />;
	const { cancelledByEmail, cancelledAt, cancelReason } = lineItem;
	const hasCancellationDetails =
		lineItem.status === PURCHASE_REQUEST_STATUSES.cancelled &&
		(cancelledByEmail || cancelledAt || cancelReason);
	return hasCancellationDetails ? (
		<Popover content={<CancellationSummary lineItem={lineItem} />}>
			<span>{chip}</span>
		</Popover>
	) : (
		chip
	);
};
